import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestHelper } from '@shared/helpers/request.helper';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class EnrolmentApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/enrolments`;
    }

    getEnrolments(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }

    searchEnrolments(req: PaginationRequest, body: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/search`, body, { params: options });
    }

    createEnrolment(enrolment: any): Observable<any> {
        return this.httpClient.post<any>(this.url, enrolment);
    }

    updateEnrolment(enrolment: any): Observable<any> {
        return this.httpClient.put<any>(this.url, enrolment);
    }
}

